<form [formGroup]="formImpuesto" class="row" (ngSubmit)="agregarImpuesto()">
    <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Impuesto <i class="fas fa-asterisk text-danger"></i></label>
        <select (ngModelChange)="selectImpuesto()" class="form-select" formControlName="impuesto">
            <option [value]="">Selecciona una opción</option>
            @for (impuesto of catImpuestos; track $index) {
                <option [value]="impuesto.cImpuesto">
                    {{ impuesto.cImpuesto }} - {{ impuesto.descripcion }}
                </option>
            }
        </select>
    </div>
    <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Impuesto <i class="fas fa-asterisk text-danger"></i></label>
        <input class="form-control" [value]="tipoImpuesto" [readOnly]="true" />
    </div>
    <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Traslado/Retención <i class="fas fa-asterisk text-danger"></i></label>
        <select class="form-select" (change)="setTrasRet($event)" [value]="trasladoRetencion">
            <option [value]="">Selecciona una opción</option>
            <option value="traslado">Traslado</option>
            @if (impuestoTemporal) {
                @if (impuestoTemporal.retencion === 'Si') {
                    <option value="retencion">Retención</option>
                }
            }
         
        </select>
    </div>
    <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Tipo factor <i class="fas fa-asterisk text-danger"></i></label>
        <select (ngModelChange)="selectTipoFactor()" class="form-select" formControlName="tipoFactor">
            <option [value]="">Selecciona una opción</option>
            @for (factor of catTipoFactor; track $index) {
                <option [value]="factor.value">{{ factor.value }}</option>
            }
        </select>
    </div>
    <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Tasa o Cuota <i class="fas fa-asterisk text-danger"></i></label>
        <input class="form-control" type="number" (input)="setTasaOCuota()" [readOnly]="isTasaReadOnly" formControlName="tasaoCuota" />
        @if (this.formImpuesto.value['tipoFactor'] === 'Tasa') {
            <div class="d-flex mt-1 align-items-center">
                <input type="range" class="form-range" (input)="calcularPAplicacion($event)" [min]="0" [max]="100" [step]="1" [value]="pAplicacion">
                <small class="ms-2">%{{ pAplicacion }}</small>
            </div>
        }  
    </div>
    <div class="col-12 text-end">
        <button type="submit" class="btn btn-success btn-sm"><i class="fas fa-plus me-1"></i>Añadir impuesto</button>
    </div>
</form>

<div class="row">
    <div class="col-md-6">
        <h6>Trasladados</h6>
        <table class="table table-sm table-bordered">
            <caption></caption>
            <thead>
                <tr>
                    <th class="text-center" style="font-size: 14px;">Impuesto</th>
                    <th class="text-center" style="font-size: 14px;">Tipo factor</th>
                    <th class="text-center" style="font-size: 14px;">Tasa o Cuota</th>
                    <th class="text-center" style="font-size: 14px;">Importe</th>
                    <th class="text-center" style="font-size: 14px;">Eliminar</th>
                </tr>
            </thead>
            <tbody>
                @for (impuesto of getTraslados().value; track $index) {
                    <tr>
                        <td class="text-center align-middle" style="font-size: 12px;">{{ impuesto.impuesto }}</td>
                        <td class="text-center align-middle" style="font-size: 12px;">{{ impuesto.tipoFactor }}</td>
                        <td class="text-end align-middle" style="font-size: 12px;">{{ impuesto.tasaoCuota }}</td>
                        <td class="text-end align-middle" style="font-size: 12px;">{{ impuesto.importe | currency }}</td>
                        <td class="text-center"><a (click)="removeTraslado($index)" class="text-danger" title="Eliminar impuesto" style="font-size: 14px; cursor: pointer;"><i class="fas fa-trash"></i></a></td>
                    </tr>
                }@empty {
                    <tr>
                        <td [colSpan]="5" class="text-center" style="font-size: 12px;">Aún no se añaden impuestos trasladados.</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    <div class="col-md-6">
        <h6>Retenidos</h6>
        <table class="table table-sm table-bordered">
            <caption></caption>
            <thead>
                <tr>
                    <th class="text-center" style="font-size: 14px;">Impuesto</th>
                    <th class="text-center" style="font-size: 14px;">Tipo factor</th>
                    <th class="text-center" style="font-size: 14px;">Tasa o Cuota</th>
                    <th class="text-center" style="font-size: 14px;">Importe</th>
                    <th class="text-center" style="font-size: 14px;">Eliminar</th>
                </tr>
            </thead>
            <tbody>
                @for (impuesto of getRetenciones().value; track $index) {
                    <tr>
                        <td class="text-center align-middle" style="font-size: 12px;">{{ impuesto.impuesto }}</td>
                        <td class="text-center align-middle" style="font-size: 12px;">{{ impuesto.tipoFactor }}</td>
                        <td class="text-end align-middle" style="font-size: 12px;">{{ impuesto.tasaoCuota }}</td>
                        <td class="text-end align-middle" style="font-size: 12px;">{{ impuesto.importe | currency }}</td>
                        <td class="text-center"><a (click)="removeRetencion($index)" class="text-danger" title="Eliminar impuesto" style="font-size: 14px; cursor: pointer;"><i class="fas fa-trash"></i></a></td>
                    </tr>
                }@empty {
                    <tr>
                        <td [colSpan]="5" class="text-center" style="font-size: 12px;">Aún no se añaden impuestos retenidos.</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>

<app-custom-toaster></app-custom-toaster>